var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bannerIndex < _vm.banners.length)?_c('alert-banner',{key:_vm.bannerIndex,attrs:{"banner":_vm.banners[_vm.bannerIndex]},on:{"input":_vm.nextIndex}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }